import { render, staticRenderFns } from "./EditUserInternalPermissionModal.vue?vue&type=template&id=085b2f0b"
import script from "./EditUserInternalPermissionModal.vue?vue&type=script&lang=js"
export * from "./EditUserInternalPermissionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports